/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContainerBox = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 25 24" {...props}>
    <path d="M.667 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4h-16a4 4 0 0 1-4-4V4Z" />
    <path
      fill="#fff"
      d="m12.667 5.4 5.7 3.3v6.6l-5.7 3.3-5.7-3.3V8.7l5.7-3.3Zm-3.3 5.382 2.7 1.563v3.03h1.2v-3.03l2.7-1.563-.6-1.039-2.7 1.563-2.7-1.563-.6 1.039Z"
    />
  </svg>
);

export default SvgContainerBox;
